import { render } from "./GraphPanelIsland.vue?vue&type=template&id=56c02483"
import script from "./GraphPanelIsland.vue?vue&type=script&lang=js"
export * from "./GraphPanelIsland.vue?vue&type=script&lang=js"

import "./GraphPanelIsland.vue?vue&type=style&index=0&id=56c02483&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/graph/GraphPanelIsland.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56c02483"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56c02483', __exports__)) {
    api.reload('56c02483', __exports__)
  }
  
  module.hot.accept("./GraphPanelIsland.vue?vue&type=template&id=56c02483", () => {
    api.rerender('56c02483', render)
  })

}


export default __exports__